import { API_CONFIG } from '../config/api';
import { consentAllows } from '../features/consent/consentStore';

// Performance monitoring configuration
const PERFORMANCE_CONFIG = {
  // Send metrics to analytics in production
  sendToAnalytics: process.env.NODE_ENV === 'production',
  // Threshold values for performance monitoring
  thresholds: {
    LCP: 2500, // Largest Contentful Paint
    FID: 100,  // First Input Delay
    CLS: 0.1,  // Cumulative Layout Shift
    FCP: 1800, // First Contentful Paint
    TTFB: 600  // Time to First Byte
  }
};

// Sends one web-vitals metric. Only with Analytics consent: both the gtag
// event and our own /api/analytics/web-vitals beacon (which carries the page URL).
export const sendToAnalytics = (metric) => {
  const { name, value, delta } = metric;
  if (!consentAllows('analytics')) return;
  const isInIframe = typeof window !== 'undefined' && window.self !== window.top;

  // Send to analytics service in production (skip when in iframe to avoid 400 and duplicate requests)
  if (PERFORMANCE_CONFIG.sendToAnalytics && !isInIframe) {
    try {
      if (window.gtag) {
        window.gtag('event', name, {
          event_category: 'Web Vitals',
          event_label: name,
          value: Math.round(value),
          custom_parameter_1: getRating(name, value),
          non_interaction: true
        });
      }

      const base = (typeof API_CONFIG !== 'undefined' && API_CONFIG.baseURL) ? API_CONFIG.baseURL : '';
      fetch(`${base}/api/analytics/web-vitals`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name,
          value: Math.round(value),
          delta: Math.round(delta),
          rating: getRating(name, value),
          url: window.location.href,
          timestamp: Date.now()
        })
      }).catch(() => {
        // Silently fail analytics
      });
    } catch (error) {
      // Silently fail analytics
    }
  }
};

// Get performance rating based on thresholds
const getRating = (name, value) => {
  switch (name) {
    case 'LCP':
      return value <= 2500 ? 'good' : value <= 4000 ? 'needs-improvement' : 'poor';
    case 'FID':
      return value <= 100 ? 'good' : value <= 300 ? 'needs-improvement' : 'poor';
    case 'CLS':
      return value <= 0.1 ? 'good' : value <= 0.25 ? 'needs-improvement' : 'poor';
    case 'FCP':
      return value <= 1800 ? 'good' : value <= 3000 ? 'needs-improvement' : 'poor';
    case 'TTFB':
      return value <= 600 ? 'good' : value <= 1500 ? 'needs-improvement' : 'poor';
    default:
      return 'unknown';
  }
};
